import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyContact from "./StickyContact";
import ChatWidget from "./ChatWidget";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main><Outlet /></main>
      <Footer />
      <StickyContact />
      <ChatWidget />
    </div>
  );
}
